import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { ApiAuthService } from '../auth.service';

export const apiNoAuthGuardWithParams = (params: any = {}) => {
  return () => {
    const router = inject(Router);
    const apiAuthSrv = inject(ApiAuthService);
    return apiAuthSrv.logged(params).pipe(
      map((result) => {
        if (result) {
          router.navigate(['/travel']);
          return false;
        } else {
          return true;
        }
      })
    );
  };
};

export const apiNoAuthGuard = apiNoAuthGuardWithParams();
